import React from 'react';
import {
  CheckCircle,
  Clock,
  Circle
} from 'lucide-react';
import { SubtramiteEstado } from '@/subtramites/types';

interface StatusIconProps {
  status: SubtramiteEstado;
  className?: string;
}

export const StatusIcon: React.FC<StatusIconProps> = ({ status, className = "w-4 h-4" }) => {
  switch (status) {
    case 'finalizado':
      return <CheckCircle className={`${className} text-green-600`} />;
    case 'en-proceso':
      return <Clock className={`${className} text-orange-600`} />;
    case 'pendiente':
      return <Circle className={`${className} text-gray-400`} />;
    default:
      return <Circle className={`${className} text-gray-400`} />;
  }
};
